// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3FyJb","signatureBlock":"Footer_signatureBlock__1u0iQ","signature":"Footer_signature__2y6S7"};